var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_92",
    "data-name": "Layer 92",
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.196,
    height: 13.199,
    viewBox: "0 0 13.196 13.199",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_242482",
    "data-name": "Path 242482",
    d: "M19,2.6a1.981,1.981,0,0,0-2.819,0L14.91,3.884l2.8,2.8,1.268-1.268A1.981,1.981,0,0,0,19,2.6Z",
    transform: "translate(-6.395 -2.008)",
    fill: "#515255"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_242483",
    "data-name": "Path 242483",
    d: "M9.59,6.27,4.051,11.809a.759.759,0,0,0-.125.172l-1.835,3.7a.657.657,0,0,0,.865.9l3.7-1.835a.759.759,0,0,0,.172-.125L12.37,9.089Z",
    transform: "translate(-2.013 -3.456)",
    fill: "#515255"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_242484",
    "data-name": "Path 242484",
    d: "M17.6,21.32H11.66a.66.66,0,0,1,0-1.32H17.6a.66.66,0,0,1,0,1.32Z",
    transform: "translate(-5.066 -8.121)",
    fill: "#fd930d"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.be8d534b4845af4982cc63116f1e0f42.svg";
export { ForwardRef as ReactComponent };